var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgChatListOrderedi = function SvgChatListOrderedi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M6.868 16.248a.393.393 0 0 1-.367-.375 1.39 1.39 0 0 1 .7-1.074c.192-.152.374-.291.374-.4 0-.027-.019-.082-.128-.082a.12.12 0 0 0-.119.125.39.39 0 0 1-.374.375.386.386 0 0 1-.369-.375.93.93 0 0 1 .206-.561.83.83 0 0 1 .656-.3.833.833 0 0 1 .869.838 1.27 1.27 0 0 1-.676 1 .5.5 0 0 0-.108.09h.465a.39.39 0 0 1 .374.373.4.4 0 0 1-.374.375zm2.792-.861a.405.405 0 0 1-.409-.422.406.406 0 0 1 .409-.416h7.429a.41.41 0 0 1 .41.416.41.41 0 0 1-.41.422zm0-2.787a.407.407 0 0 1-.409-.418.406.406 0 0 1 .409-.42h7.429a.41.41 0 0 1 .41.42.41.41 0 0 1-.41.418zm-2.473-2.311v-.867a.4.4 0 0 1-.566-.016.43.43 0 0 1 0-.6l.688-.7a.43.43 0 0 1 .44-.086.43.43 0 0 1 .266.391v1.871a.427.427 0 0 1-.416.418.41.41 0 0 1-.411-.411zm2.473-.475a.41.41 0 0 1-.409-.418.405.405 0 0 1 .409-.422h7.429a.406.406 0 0 1 .41.422.41.41 0 0 1-.41.418z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChatListOrderedi);
export default ForwardRef;